export const countryList = [
  {
    "Recno": 50078,
    "Landsnr": 46,
    "Landkod": "SWE",
    "Land": "Sverige",
    "Valuta": "SEK"
  },
  {
    "Recno": 50011,
    "Landsnr": 45,
    "Landkod": "DNK",
    "Land": "Danmark",
    "Valuta": "DKK"
  },
  {
    "Recno": 50009,
    "Landsnr": 47,
    "Landkod": "NOR",
    "Land": "Norge",
    "Valuta": "NOK"
  },
  {
    "Recno": 50079,
    "Landsnr": 358,
    "Landkod": "FIN",
    "Land": "Finland",
    "Valuta": "EUR"
  },
  {
    "Recno": 50081,
    "Landsnr": 44,
    "Landkod": "GBR",
    "Land": "Storbritannien",
    "Valuta": "GBP"
  },
  {
    "Recno": 50086,
    "Landsnr": 32,
    "Landkod": "BEL",
    "Land": "Belgien",
    "Valuta": "EUR"
  },
  {
    "Recno": 50103,
    "Landsnr": 372,
    "Landkod": "EST",
    "Land": "Estland",
    "Valuta": "EEK"
  },
  {
    "Recno": 50087,
    "Landsnr": 33,
    "Landkod": "FRA",
    "Land": "Frankrike",
    "Valuta": "EUR"
  },
  {
    "Recno": 50096,
    "Landsnr": 30,
    "Landkod": "GRC",
    "Land": "Grekland",
    "Valuta": "EUR"
  },
  {
    "Recno": 50095,
    "Landsnr": 353,
    "Landkod": "IRL",
    "Land": "Irland",
    "Valuta": "EUR"
  },
  {
    "Recno": 50224,
    "Landsnr": 354,
    "Landkod": "ISL",
    "Land": "Island",
    "Valuta": "DEM"
  },
  {
    "Recno": 50088,
    "Landsnr": 39,
    "Landkod": "ITA",
    "Land": "Italien",
    "Valuta": "EUR"
  },
  {
    "Recno": 50102,
    "Landsnr": 371,
    "Landkod": "LVA",
    "Land": "Lettland",
    "Valuta": "LVL"
  },
  {
    "Recno": 50104,
    "Landsnr": 370,
    "Landkod": "LTU",
    "Land": "Litauen",
    "Valuta": "LTL"
  },
  {
    "Recno": 50090,
    "Landsnr": 352,
    "Landkod": "LUX",
    "Land": "Luxemburg",
    "Valuta": "EUR"
  },
  {
    "Recno": 50077,
    "Landsnr": 31,
    "Landkod": "NLD",
    "Land": "Nederländerna",
    "Valuta": "EUR"
  },
  {
    "Recno": 50091,
    "Landsnr": 41,
    "Landkod": "CHE",
    "Land": "Schweiz",
    "Valuta": "CHF"
  },
  {
    "Recno": 50092,
    "Landsnr": 34,
    "Landkod": "ESP",
    "Land": "Spanien",
    "Valuta": "EUR"
  },
  {
    "Recno": 50085,
    "Landsnr": 49,
    "Landkod": "DEU",
    "Land": "Tyskland",
    "Valuta": "EUR"
  },
  {
    "Recno": 50093,
    "Landsnr": 43,
    "Landkod": "AUT",
    "Land": "Österrike",
    "Valuta": "EUR"
  },
  {
    "Recno": 29,
    "Landsnr": 93,
    "Landkod": "AFG",
    "Land": "Afghanistan",
    "Valuta": ""
  },
  {
    "Recno": 27,
    "Landsnr": 355,
    "Landkod": "ALB",
    "Land": "Albanien",
    "Valuta": "ALL"
  },
  {
    "Recno": 73,
    "Landsnr": 213,
    "Landkod": "DZA",
    "Land": "Algeriet",
    "Valuta": ""
  },
  {
    "Recno": 37,
    "Landsnr": "1 684",
    "Landkod": "ASM",
    "Land": "Amerikanska Samoa",
    "Valuta": ""
  },
  {
    "Recno": 26,
    "Landsnr": 376,
    "Landkod": "AND",
    "Land": "Andorra",
    "Valuta": "EUR"
  },
  {
    "Recno": 34,
    "Landsnr": 244,
    "Landkod": "AGO",
    "Land": "Angola",
    "Valuta": ""
  },
  {
    "Recno": 31,
    "Landsnr": "1 264",
    "Landkod": "AIA",
    "Land": "Anguilla",
    "Valuta": ""
  },
  {
    "Recno": 35,
    "Landsnr": "",
    "Landkod": "ATA",
    "Land": "Antarktis",
    "Valuta": ""
  },
  {
    "Recno": 30,
    "Landsnr": "1 268",
    "Landkod": "ATG",
    "Land": "Antigua och Barbuda",
    "Valuta": ""
  },
  {
    "Recno": 36,
    "Landsnr": 54,
    "Landkod": "ARG",
    "Land": "Argentina",
    "Valuta": ""
  },
  {
    "Recno": 32,
    "Landsnr": 374,
    "Landkod": "ARM",
    "Land": "Armenien",
    "Valuta": ""
  },
  {
    "Recno": 39,
    "Landsnr": 297,
    "Landkod": "ABW",
    "Land": "Aruba",
    "Valuta": ""
  },
  {
    "Recno": 38,
    "Landsnr": 61,
    "Landkod": "AUS",
    "Land": "Australien",
    "Valuta": ""
  },
  {
    "Recno": 25,
    "Landsnr": 994,
    "Landkod": "AZE",
    "Land": "Azerbajdzjan",
    "Valuta": "AZM"
  },
  {
    "Recno": 50,
    "Landsnr": "1 242",
    "Landkod": "BHS",
    "Land": "Bahamas",
    "Valuta": ""
  },
  {
    "Recno": 43,
    "Landsnr": 973,
    "Landkod": "BHR",
    "Land": "Bahrain",
    "Valuta": ""
  },
  {
    "Recno": 41,
    "Landsnr": 880,
    "Landkod": "BGD",
    "Land": "Bangladesh",
    "Valuta": ""
  },
  {
    "Recno": 40,
    "Landsnr": "1 246",
    "Landkod": "BRB",
    "Land": "Barbados",
    "Valuta": ""
  },
  {
    "Recno": 54,
    "Landsnr": 501,
    "Landkod": "BLZ",
    "Land": "Belize",
    "Valuta": ""
  },
  {
    "Recno": 45,
    "Landsnr": 229,
    "Landkod": "BEN",
    "Land": "Benin",
    "Valuta": ""
  },
  {
    "Recno": 46,
    "Landsnr": "1 441",
    "Landkod": "BMU",
    "Land": "Bermuda",
    "Valuta": ""
  },
  {
    "Recno": 51,
    "Landsnr": 975,
    "Landkod": "BTN",
    "Land": "Bhutan",
    "Valuta": ""
  },
  {
    "Recno": 48,
    "Landsnr": 591,
    "Landkod": "BOL",
    "Land": "Bolivia",
    "Valuta": ""
  },
  {
    "Recno": 223,
    "Landsnr": 599,
    "Landkod": "BES",
    "Land": "Bonaire, Sint Eustatius och Saba",
    "Valuta": ""
  },
  {
    "Recno": 23,
    "Landsnr": 387,
    "Landkod": "BIH",
    "Land": "Bosnien-Hercegovina",
    "Valuta": "BAM"
  },
  {
    "Recno": 53,
    "Landsnr": 267,
    "Landkod": "BWA",
    "Land": "Botswana",
    "Valuta": ""
  },
  {
    "Recno": 52,
    "Landsnr": "",
    "Landkod": "BVT",
    "Land": "Bouvetön",
    "Valuta": ""
  },
  {
    "Recno": 49,
    "Landsnr": 55,
    "Landkod": "BRA",
    "Land": "Brasilien",
    "Valuta": ""
  },
  {
    "Recno": 209,
    "Landsnr": "1 284",
    "Landkod": "VGB",
    "Land": "British Virgin Islands",
    "Valuta": ""
  },
  {
    "Recno": 105,
    "Landsnr": 246,
    "Landkod": "IOT",
    "Land": "Brittiska territoriet i Indiska Oceanen",
    "Valuta": ""
  },
  {
    "Recno": 47,
    "Landsnr": 673,
    "Landkod": "BRN",
    "Land": "Brunei",
    "Valuta": ""
  },
  {
    "Recno": 22,
    "Landsnr": 359,
    "Landkod": "BGR",
    "Land": "Bulgarien",
    "Valuta": "BGL"
  },
  {
    "Recno": 42,
    "Landsnr": 226,
    "Landkod": "BFA",
    "Land": "Burkina Faso",
    "Valuta": ""
  },
  {
    "Recno": 133,
    "Landsnr": 95,
    "Landkod": "MMR",
    "Land": "Burma (Myanmar)",
    "Valuta": ""
  },
  {
    "Recno": 44,
    "Landsnr": 257,
    "Landkod": "BDI",
    "Land": "Burundi",
    "Valuta": ""
  },
  {
    "Recno": 120,
    "Landsnr": "1 345",
    "Landkod": "CYM",
    "Land": "Caymanöarna",
    "Valuta": ""
  },
  {
    "Recno": 56,
    "Landsnr": 236,
    "Landkod": "CAF",
    "Land": "Centralafrikanska republiken",
    "Valuta": ""
  },
  {
    "Recno": 60,
    "Landsnr": 56,
    "Landkod": "CHL",
    "Land": "Chile",
    "Valuta": ""
  },
  {
    "Recno": 63,
    "Landsnr": 57,
    "Landkod": "COL",
    "Land": "Colombia",
    "Valuta": ""
  },
  {
    "Recno": 59,
    "Landsnr": 682,
    "Landkod": "COK",
    "Land": "Cooköarna",
    "Valuta": ""
  },
  {
    "Recno": 64,
    "Landsnr": 506,
    "Landkod": "CRI",
    "Land": "Costa Rica",
    "Valuta": ""
  },
  {
    "Recno": 232,
    "Landsnr": 599,
    "Landkod": "CUW",
    "Land": "Curacao",
    "Valuta": ""
  },
  {
    "Recno": 33,
    "Landsnr": 599,
    "Landkod": "ANT",
    "Land": "Curaçao",
    "Valuta": ""
  },
  {
    "Recno": 68,
    "Landsnr": 357,
    "Landkod": "CYP",
    "Land": "Cypern",
    "Valuta": ""
  },
  {
    "Recno": 231,
    "Landsnr": 243,
    "Landkod": "COD",
    "Land": "Democratic Republic of the Congo",
    "Valuta": ""
  },
  {
    "Recno": 57,
    "Landsnr": "",
    "Landkod": "COG",
    "Land": "Demokratiska Republiken Kongo",
    "Valuta": ""
  },
  {
    "Recno": 70,
    "Landsnr": 253,
    "Landkod": "DJI",
    "Land": "Djibouti",
    "Valuta": ""
  },
  {
    "Recno": 71,
    "Landsnr": "1 767",
    "Landkod": "DMA",
    "Land": "Dominica",
    "Valuta": ""
  },
  {
    "Recno": 72,
    "Landsnr": "1 809",
    "Landkod": "DOM",
    "Land": "Dominikanska republiken",
    "Valuta": ""
  },
  {
    "Recno": 74,
    "Landsnr": 593,
    "Landkod": "ECU",
    "Land": "Ecuador",
    "Valuta": ""
  },
  {
    "Recno": 75,
    "Landsnr": 20,
    "Landkod": "EGY",
    "Land": "Egypten",
    "Valuta": ""
  },
  {
    "Recno": 93,
    "Landsnr": 240,
    "Landkod": "GNQ",
    "Land": "Ekvatorialguinea",
    "Valuta": ""
  },
  {
    "Recno": 184,
    "Landsnr": 503,
    "Landkod": "SLV",
    "Land": "El Salvador",
    "Valuta": ""
  },
  {
    "Recno": 58,
    "Landsnr": "",
    "Landkod": "CIV",
    "Land": "Elfenbenskusten",
    "Valuta": ""
  },
  {
    "Recno": 77,
    "Landsnr": 291,
    "Landkod": "ERI",
    "Land": "Eritrea",
    "Valuta": ""
  },
  {
    "Recno": 78,
    "Landsnr": 251,
    "Landkod": "ETH",
    "Land": "Etiopien",
    "Valuta": ""
  },
  {
    "Recno": 80,
    "Landsnr": 500,
    "Landkod": "FLK",
    "Land": "Falklandsöarna",
    "Valuta": ""
  },
  {
    "Recno": 79,
    "Landsnr": 679,
    "Landkod": "FJI",
    "Land": "Fiji",
    "Valuta": ""
  },
  {
    "Recno": 161,
    "Landsnr": 63,
    "Landkod": "PHL",
    "Land": "Filippinerna",
    "Valuta": ""
  },
  {
    "Recno": 83,
    "Landsnr": 33,
    "Landkod": "FXX",
    "Land": "Frankrike (europeiska)",
    "Valuta": ""
  },
  {
    "Recno": 86,
    "Landsnr": 594,
    "Landkod": "GUF",
    "Land": "Franska Guyana",
    "Valuta": ""
  },
  {
    "Recno": 159,
    "Landsnr": 689,
    "Landkod": "PYF",
    "Land": "Franska Polynesien",
    "Valuta": ""
  },
  {
    "Recno": 189,
    "Landsnr": "",
    "Landkod": "ATF",
    "Land": "Franska södra territorierna",
    "Valuta": ""
  },
  {
    "Recno": 82,
    "Landsnr": 298,
    "Landkod": "FRO",
    "Land": "Färöarna",
    "Valuta": ""
  },
  {
    "Recno": 28,
    "Landsnr": 971,
    "Landkod": "ARE",
    "Land": "Förenade arabemiraten",
    "Valuta": ""
  },
  {
    "Recno": 84,
    "Landsnr": 241,
    "Landkod": "GAB",
    "Land": "Gabon",
    "Valuta": ""
  },
  {
    "Recno": 90,
    "Landsnr": 220,
    "Landkod": "GMB",
    "Land": "Gambia",
    "Valuta": ""
  },
  {
    "Recno": 20,
    "Landsnr": 995,
    "Landkod": "GEO",
    "Land": "Georgien",
    "Valuta": "GEL"
  },
  {
    "Recno": 87,
    "Landsnr": 233,
    "Landkod": "GHA",
    "Land": "Ghana",
    "Valuta": ""
  },
  {
    "Recno": 88,
    "Landsnr": 350,
    "Landkod": "GIB",
    "Land": "Gibraltar",
    "Valuta": ""
  },
  {
    "Recno": 89,
    "Landsnr": 299,
    "Landkod": "GRL",
    "Land": "Greenland",
    "Valuta": ""
  },
  {
    "Recno": 85,
    "Landsnr": "1 473",
    "Landkod": "GRD",
    "Land": "Grenada",
    "Valuta": ""
  },
  {
    "Recno": 92,
    "Landsnr": 590,
    "Landkod": "GLP",
    "Land": "Guadeloupe",
    "Valuta": ""
  },
  {
    "Recno": 95,
    "Landsnr": "1 671",
    "Landkod": "GUM",
    "Land": "Guam",
    "Valuta": ""
  },
  {
    "Recno": 94,
    "Landsnr": 502,
    "Landkod": "GTM",
    "Land": "Guatemala",
    "Valuta": ""
  },
  {
    "Recno": 225,
    "Landsnr": "",
    "Landkod": "GGY",
    "Land": "Guernsey",
    "Valuta": ""
  },
  {
    "Recno": 91,
    "Landsnr": 224,
    "Landkod": "GIN",
    "Land": "Guinea",
    "Valuta": ""
  },
  {
    "Recno": 96,
    "Landsnr": 245,
    "Landkod": "GNB",
    "Land": "Guinea Bissau",
    "Valuta": ""
  },
  {
    "Recno": 97,
    "Landsnr": 592,
    "Landkod": "GUY",
    "Land": "Guyana",
    "Valuta": ""
  },
  {
    "Recno": 101,
    "Landsnr": 509,
    "Landkod": "HTI",
    "Land": "Haiti",
    "Valuta": ""
  },
  {
    "Recno": 99,
    "Landsnr": "",
    "Landkod": "HMD",
    "Land": "Heard- och McDonaldsöarna",
    "Valuta": ""
  },
  {
    "Recno": 100,
    "Landsnr": 504,
    "Landkod": "HND",
    "Land": "Honduras",
    "Valuta": ""
  },
  {
    "Recno": 98,
    "Landsnr": 852,
    "Landkod": "HKG",
    "Land": "Hongkong",
    "Valuta": ""
  },
  {
    "Recno": 104,
    "Landsnr": 91,
    "Landkod": "IND",
    "Land": "Indien",
    "Valuta": ""
  },
  {
    "Recno": 102,
    "Landsnr": 62,
    "Landkod": "IDN",
    "Land": "Indonesien",
    "Valuta": ""
  },
  {
    "Recno": 106,
    "Landsnr": 964,
    "Landkod": "IRQ",
    "Land": "Irak",
    "Valuta": ""
  },
  {
    "Recno": 107,
    "Landsnr": 98,
    "Landkod": "IRN",
    "Land": "Iran",
    "Valuta": ""
  },
  {
    "Recno": 226,
    "Landsnr": "",
    "Landkod": "IMN",
    "Land": "Isle of Man",
    "Valuta": ""
  },
  {
    "Recno": 103,
    "Landsnr": 972,
    "Landkod": "ISR",
    "Land": "Israel",
    "Valuta": ""
  },
  {
    "Recno": 108,
    "Landsnr": "1 876",
    "Landkod": "JAM",
    "Land": "Jamaica",
    "Valuta": ""
  },
  {
    "Recno": 110,
    "Landsnr": 81,
    "Landkod": "JPN",
    "Land": "Japan",
    "Valuta": ""
  },
  {
    "Recno": 227,
    "Landsnr": "",
    "Landkod": "JEY",
    "Land": "Jersey",
    "Valuta": ""
  },
  {
    "Recno": 109,
    "Landsnr": 962,
    "Landkod": "JOR",
    "Land": "Jordanien",
    "Valuta": ""
  },
  {
    "Recno": 67,
    "Landsnr": 61,
    "Landkod": "CXR",
    "Land": "Julön",
    "Valuta": ""
  },
  {
    "Recno": 210,
    "Landsnr": "1 340",
    "Landkod": "VIR",
    "Land": "Jungfruöarna USA",
    "Valuta": ""
  },
  {
    "Recno": 113,
    "Landsnr": 855,
    "Landkod": "KHM",
    "Land": "Kambodja",
    "Valuta": ""
  },
  {
    "Recno": 61,
    "Landsnr": 237,
    "Landkod": "CMR",
    "Land": "Kamerun",
    "Valuta": ""
  },
  {
    "Recno": 50083,
    "Landsnr": 1,
    "Landkod": "CAN",
    "Land": "Kanada",
    "Valuta": "CAD"
  },
  {
    "Recno": 66,
    "Landsnr": 238,
    "Landkod": "CPV",
    "Land": "Kap Verde",
    "Valuta": ""
  },
  {
    "Recno": 18,
    "Landsnr": 7,
    "Landkod": "KAZ",
    "Land": "Kazakstan",
    "Valuta": "KZT"
  },
  {
    "Recno": 111,
    "Landsnr": 254,
    "Landkod": "KEN",
    "Land": "Kenya",
    "Valuta": ""
  },
  {
    "Recno": 62,
    "Landsnr": 86,
    "Landkod": "CHN",
    "Land": "Kina",
    "Valuta": ""
  },
  {
    "Recno": 112,
    "Landsnr": 996,
    "Landkod": "KGZ",
    "Land": "Kirgizistan",
    "Valuta": ""
  },
  {
    "Recno": 114,
    "Landsnr": 686,
    "Landkod": "KIR",
    "Land": "Kiribati",
    "Valuta": ""
  },
  {
    "Recno": 55,
    "Landsnr": "",
    "Landkod": "CCK",
    "Land": "Kokosöarna",
    "Valuta": ""
  },
  {
    "Recno": 115,
    "Landsnr": 269,
    "Landkod": "COM",
    "Land": "Komorerna",
    "Valuta": ""
  },
  {
    "Recno": 50225,
    "Landsnr": 381,
    "Landkod": "UNK",
    "Land": "Kosovo",
    "Valuta": ""
  },
  {
    "Recno": 21,
    "Landsnr": 385,
    "Landkod": "HRV",
    "Land": "Kroatien",
    "Valuta": "HRD"
  },
  {
    "Recno": 65,
    "Landsnr": 53,
    "Landkod": "CUB",
    "Land": "Kuba",
    "Valuta": ""
  },
  {
    "Recno": 119,
    "Landsnr": 965,
    "Landkod": "KWT",
    "Land": "Kuwait",
    "Valuta": ""
  },
  {
    "Recno": 121,
    "Landsnr": 856,
    "Landkod": "LAO",
    "Land": "Laos",
    "Valuta": ""
  },
  {
    "Recno": 126,
    "Landsnr": 266,
    "Landkod": "LSO",
    "Land": "Lesotho",
    "Valuta": ""
  },
  {
    "Recno": 122,
    "Landsnr": 961,
    "Landkod": "LBN",
    "Land": "Libanon",
    "Valuta": ""
  },
  {
    "Recno": 125,
    "Landsnr": 231,
    "Landkod": "LBR",
    "Land": "Liberia",
    "Valuta": ""
  },
  {
    "Recno": 127,
    "Landsnr": 218,
    "Landkod": "LBY",
    "Land": "Libyen",
    "Valuta": ""
  },
  {
    "Recno": 17,
    "Landsnr": 423,
    "Landkod": "LIE",
    "Land": "Liechtenstein",
    "Valuta": "CHF"
  },
  {
    "Recno": 135,
    "Landsnr": 853,
    "Landkod": "MAC",
    "Land": "Macao",
    "Valuta": ""
  },
  {
    "Recno": 130,
    "Landsnr": 261,
    "Landkod": "MDG",
    "Land": "Madagaskar",
    "Valuta": ""
  },
  {
    "Recno": 16,
    "Landsnr": 389,
    "Landkod": "MKD",
    "Land": "Makedonien",
    "Valuta": "MKD"
  },
  {
    "Recno": 142,
    "Landsnr": 265,
    "Landkod": "MWI",
    "Land": "Malawi",
    "Valuta": ""
  },
  {
    "Recno": 144,
    "Landsnr": 60,
    "Landkod": "MYS",
    "Land": "Malaysia",
    "Valuta": ""
  },
  {
    "Recno": 141,
    "Landsnr": 960,
    "Landkod": "MDV",
    "Land": "Maldiverna",
    "Valuta": ""
  },
  {
    "Recno": 132,
    "Landsnr": 223,
    "Landkod": "MLI",
    "Land": "Mali",
    "Valuta": ""
  },
  {
    "Recno": 15,
    "Landsnr": 356,
    "Landkod": "MLT",
    "Land": "Malta",
    "Valuta": "MTL"
  },
  {
    "Recno": 128,
    "Landsnr": 212,
    "Landkod": "MAR",
    "Land": "Marocko",
    "Valuta": ""
  },
  {
    "Recno": 131,
    "Landsnr": 692,
    "Landkod": "MHL",
    "Land": "Marshallöarna",
    "Valuta": ""
  },
  {
    "Recno": 137,
    "Landsnr": 596,
    "Landkod": "MTQ",
    "Land": "Martinique",
    "Valuta": ""
  },
  {
    "Recno": 138,
    "Landsnr": 222,
    "Landkod": "MRT",
    "Land": "Mauritania",
    "Valuta": ""
  },
  {
    "Recno": 140,
    "Landsnr": 230,
    "Landkod": "MUS",
    "Land": "Mauritius",
    "Valuta": ""
  },
  {
    "Recno": 215,
    "Landsnr": 262,
    "Landkod": "MYT",
    "Land": "Mayotte",
    "Valuta": ""
  },
  {
    "Recno": 143,
    "Landsnr": 52,
    "Landkod": "MEX",
    "Land": "Mexiko",
    "Valuta": ""
  },
  {
    "Recno": 81,
    "Landsnr": 691,
    "Landkod": "FSM",
    "Land": "Mikronesiens federerade stater",
    "Valuta": ""
  },
  {
    "Recno": 145,
    "Landsnr": 258,
    "Landkod": "MOZ",
    "Land": "Mocambique",
    "Valuta": ""
  },
  {
    "Recno": 14,
    "Landsnr": 373,
    "Landkod": "MDA",
    "Land": "Moldavien",
    "Valuta": "MDL"
  },
  {
    "Recno": 13,
    "Landsnr": 377,
    "Landkod": "MCO",
    "Land": "Monaco",
    "Valuta": "EUR"
  },
  {
    "Recno": 134,
    "Landsnr": 976,
    "Landkod": "MNG",
    "Land": "Mongoliet",
    "Valuta": ""
  },
  {
    "Recno": 129,
    "Landsnr": 382,
    "Landkod": "MNE",
    "Land": "Montenegro",
    "Valuta": ""
  },
  {
    "Recno": 139,
    "Landsnr": "1 664",
    "Landkod": "MSR",
    "Land": "Montserrat",
    "Valuta": ""
  },
  {
    "Recno": 146,
    "Landsnr": 264,
    "Landkod": "NAM",
    "Land": "Namibia",
    "Valuta": ""
  },
  {
    "Recno": 153,
    "Landsnr": 674,
    "Landkod": "NRU",
    "Land": "Nauru",
    "Valuta": ""
  },
  {
    "Recno": 152,
    "Landsnr": 977,
    "Landkod": "NPL",
    "Land": "Nepal",
    "Valuta": ""
  },
  {
    "Recno": 151,
    "Landsnr": 505,
    "Landkod": "NIC",
    "Land": "Nicaragua",
    "Valuta": ""
  },
  {
    "Recno": 148,
    "Landsnr": 227,
    "Landkod": "NER",
    "Land": "Niger",
    "Valuta": ""
  },
  {
    "Recno": 150,
    "Landsnr": 234,
    "Landkod": "NGA",
    "Land": "Nigeria",
    "Valuta": ""
  },
  {
    "Recno": 154,
    "Landsnr": 683,
    "Landkod": "NIU",
    "Land": "Niue",
    "Valuta": ""
  },
  {
    "Recno": 117,
    "Landsnr": 850,
    "Landkod": "PRK",
    "Land": "Nordkorea",
    "Valuta": ""
  },
  {
    "Recno": 136,
    "Landsnr": "1 670",
    "Landkod": "MNP",
    "Land": "Nordmarianerna",
    "Valuta": ""
  },
  {
    "Recno": 149,
    "Landsnr": 672,
    "Landkod": "NFK",
    "Land": "Norfolkön",
    "Valuta": ""
  },
  {
    "Recno": 147,
    "Landsnr": 687,
    "Landkod": "NCL",
    "Land": "Nya Kaledonien",
    "Valuta": ""
  },
  {
    "Recno": 155,
    "Landsnr": 64,
    "Landkod": "NZL",
    "Land": "Nya Zeeland",
    "Valuta": ""
  },
  {
    "Recno": 156,
    "Landsnr": 968,
    "Landkod": "OMN",
    "Land": "Oman",
    "Valuta": ""
  },
  {
    "Recno": 162,
    "Landsnr": 92,
    "Landkod": "PAK",
    "Land": "Pakistan",
    "Valuta": ""
  },
  {
    "Recno": 166,
    "Landsnr": 680,
    "Landkod": "PLW",
    "Land": "Palau",
    "Valuta": ""
  },
  {
    "Recno": 220,
    "Landsnr": 970,
    "Landkod": "PSE",
    "Land": "Palestina",
    "Valuta": ""
  },
  {
    "Recno": 157,
    "Landsnr": 507,
    "Landkod": "PAN",
    "Land": "Panama",
    "Valuta": ""
  },
  {
    "Recno": 160,
    "Landsnr": 675,
    "Landkod": "PNG",
    "Land": "Papua Nya Guinea",
    "Valuta": ""
  },
  {
    "Recno": 167,
    "Landsnr": 595,
    "Landkod": "PRY",
    "Land": "Paraguay",
    "Valuta": ""
  },
  {
    "Recno": 158,
    "Landsnr": 51,
    "Landkod": "PER",
    "Land": "Peru",
    "Valuta": ""
  },
  {
    "Recno": 164,
    "Landsnr": 64,
    "Landkod": "PCN",
    "Land": "Pitcairn",
    "Valuta": ""
  },
  {
    "Recno": 12,
    "Landsnr": 48,
    "Landkod": "POL",
    "Land": "Polen",
    "Valuta": "EUR"
  },
  {
    "Recno": 11,
    "Landsnr": 351,
    "Landkod": "PRT",
    "Land": "Portugal",
    "Valuta": "EUR"
  },
  {
    "Recno": 165,
    "Landsnr": "1 787",
    "Landkod": "PRI",
    "Land": "Puerto Rico",
    "Valuta": ""
  },
  {
    "Recno": 168,
    "Landsnr": 974,
    "Landkod": "QAT",
    "Land": "Qatar",
    "Valuta": ""
  },
  {
    "Recno": 169,
    "Landsnr": 262,
    "Landkod": "REU",
    "Land": "Reunion",
    "Valuta": ""
  },
  {
    "Recno": 10,
    "Landsnr": 40,
    "Landkod": "ROU",
    "Land": "Rumänien",
    "Valuta": "ROL"
  },
  {
    "Recno": 171,
    "Landsnr": 250,
    "Landkod": "RWA",
    "Land": "Rwanda",
    "Valuta": ""
  },
  {
    "Recno": 9,
    "Landsnr": 7,
    "Landkod": "RUS",
    "Land": "Ryssland",
    "Valuta": "RUB"
  },
  {
    "Recno": 224,
    "Landsnr": 590,
    "Landkod": "BLM",
    "Land": "Saint Barthélemy",
    "Valuta": ""
  },
  {
    "Recno": 116,
    "Landsnr": "1 869",
    "Landkod": "KNA",
    "Land": "Saint Kitts och Nevis",
    "Valuta": ""
  },
  {
    "Recno": 123,
    "Landsnr": "1 758",
    "Landkod": "LCA",
    "Land": "Saint Lucia",
    "Valuta": ""
  },
  {
    "Recno": 228,
    "Landsnr": 590,
    "Landkod": "MAF",
    "Land": "Saint Martin (fransk del)",
    "Valuta": ""
  },
  {
    "Recno": 230,
    "Landsnr": "",
    "Landkod": "SXM",
    "Land": "Saint Martin (NL)",
    "Valuta": ""
  },
  {
    "Recno": 163,
    "Landsnr": 508,
    "Landkod": "SPM",
    "Land": "Saint Pierre och Miquelon",
    "Valuta": ""
  },
  {
    "Recno": 206,
    "Landsnr": "1 784",
    "Landkod": "VCT",
    "Land": "Saint Vincent och Grenadinerna",
    "Valuta": ""
  },
  {
    "Recno": 173,
    "Landsnr": 677,
    "Landkod": "SLB",
    "Land": "Salomonöarna",
    "Valuta": ""
  },
  {
    "Recno": 212,
    "Landsnr": 685,
    "Landkod": "WSM",
    "Land": "Samoa",
    "Valuta": ""
  },
  {
    "Recno": 8,
    "Landsnr": 378,
    "Landkod": "SMR",
    "Land": "San Marino",
    "Valuta": "EUR"
  },
  {
    "Recno": 177,
    "Landsnr": 290,
    "Landkod": "SHN",
    "Land": "Sankta Helena",
    "Valuta": ""
  },
  {
    "Recno": 183,
    "Landsnr": 239,
    "Landkod": "STP",
    "Land": "Sao Tome och Principe",
    "Valuta": ""
  },
  {
    "Recno": 172,
    "Landsnr": 966,
    "Landkod": "SAU",
    "Land": "Saudiarabien",
    "Valuta": ""
  },
  {
    "Recno": 180,
    "Landsnr": 221,
    "Landkod": "SEN",
    "Land": "Senegal",
    "Valuta": ""
  },
  {
    "Recno": 170,
    "Landsnr": 381,
    "Landkod": "SRB",
    "Land": "Serbien",
    "Valuta": ""
  },
  {
    "Recno": 174,
    "Landsnr": 248,
    "Landkod": "SYC",
    "Land": "Seychellerna",
    "Valuta": ""
  },
  {
    "Recno": 179,
    "Landsnr": 232,
    "Landkod": "SLE",
    "Land": "Sierra Leone",
    "Valuta": ""
  },
  {
    "Recno": 176,
    "Landsnr": 65,
    "Landkod": "SGP",
    "Land": "Singapore",
    "Valuta": ""
  },
  {
    "Recno": 6,
    "Landsnr": 421,
    "Landkod": "SVK",
    "Land": "Slovakien",
    "Valuta": "SKK"
  },
  {
    "Recno": 5,
    "Landsnr": 386,
    "Landkod": "SVN",
    "Land": "Slovenien",
    "Valuta": "SIT"
  },
  {
    "Recno": 181,
    "Landsnr": 252,
    "Landkod": "SOM",
    "Land": "Somalia",
    "Valuta": ""
  },
  {
    "Recno": 124,
    "Landsnr": 94,
    "Landkod": "LKA",
    "Land": "Sri Lanka",
    "Valuta": ""
  },
  {
    "Recno": 175,
    "Landsnr": 249,
    "Landkod": "SDN",
    "Land": "Sudan",
    "Valuta": ""
  },
  {
    "Recno": 182,
    "Landsnr": 597,
    "Landkod": "SUR",
    "Land": "Surinam",
    "Valuta": ""
  },
  {
    "Recno": 178,
    "Landsnr": 47,
    "Landkod": "SJM",
    "Land": "Svalbard och Jan Mayen",
    "Valuta": ""
  },
  {
    "Recno": 186,
    "Landsnr": 268,
    "Landkod": "SWZ",
    "Land": "Swaziland",
    "Valuta": ""
  },
  {
    "Recno": 216,
    "Landsnr": 27,
    "Landkod": "ZAF",
    "Land": "Sydafrika",
    "Valuta": ""
  },
  {
    "Recno": 229,
    "Landsnr": "",
    "Landkod": "SGS",
    "Land": "Sydgeorgien och Sydsandwichöarna",
    "Valuta": ""
  },
  {
    "Recno": 118,
    "Landsnr": 82,
    "Landkod": "KOR",
    "Land": "Sydkorea",
    "Valuta": ""
  },
  {
    "Recno": 221,
    "Landsnr": "",
    "Landkod": "SSD",
    "Land": "Sydsudan",
    "Valuta": ""
  },
  {
    "Recno": 185,
    "Landsnr": 963,
    "Landkod": "SYR",
    "Land": "Syrien",
    "Valuta": ""
  },
  {
    "Recno": 192,
    "Landsnr": 992,
    "Landkod": "TJK",
    "Land": "Tadzjikistan",
    "Valuta": ""
  },
  {
    "Recno": 200,
    "Landsnr": 886,
    "Landkod": "TWN",
    "Land": "Taiwan",
    "Valuta": ""
  },
  {
    "Recno": 201,
    "Landsnr": 255,
    "Landkod": "TZA",
    "Land": "Tanzania",
    "Valuta": ""
  },
  {
    "Recno": 188,
    "Landsnr": 235,
    "Landkod": "TCD",
    "Land": "Tchad",
    "Valuta": ""
  },
  {
    "Recno": 191,
    "Landsnr": 66,
    "Landkod": "THA",
    "Land": "Thailand",
    "Valuta": ""
  },
  {
    "Recno": 69,
    "Landsnr": 420,
    "Landkod": "CZE",
    "Land": "Tjeckien",
    "Valuta": ""
  },
  {
    "Recno": 190,
    "Landsnr": 228,
    "Landkod": "TGO",
    "Land": "Togo",
    "Valuta": ""
  },
  {
    "Recno": 193,
    "Landsnr": 690,
    "Landkod": "TKL",
    "Land": "Tokelau",
    "Valuta": ""
  },
  {
    "Recno": 196,
    "Landsnr": 676,
    "Landkod": "TON",
    "Land": "Tonga",
    "Valuta": ""
  },
  {
    "Recno": 198,
    "Landsnr": "1 868",
    "Landkod": "TTO",
    "Land": "Trinidad och Tobago",
    "Valuta": ""
  },
  {
    "Recno": 195,
    "Landsnr": 216,
    "Landkod": "TUN",
    "Land": "Tunisien",
    "Valuta": ""
  },
  {
    "Recno": 2,
    "Landsnr": 90,
    "Landkod": "TUR",
    "Land": "Turkiet",
    "Valuta": "TRL"
  },
  {
    "Recno": 194,
    "Landsnr": 993,
    "Landkod": "TKM",
    "Land": "Turkmenistan",
    "Valuta": ""
  },
  {
    "Recno": 187,
    "Landsnr": "1 649",
    "Landkod": "TCA",
    "Land": "Turks och Caicosöarna",
    "Valuta": ""
  },
  {
    "Recno": 199,
    "Landsnr": 688,
    "Landkod": "TUV",
    "Land": "Tuvalu",
    "Valuta": ""
  },
  {
    "Recno": 202,
    "Landsnr": 256,
    "Landkod": "UGA",
    "Land": "Uganda",
    "Valuta": ""
  },
  {
    "Recno": 3,
    "Landsnr": 380,
    "Landkod": "UKR",
    "Land": "Ukraina",
    "Valuta": "UAH"
  },
  {
    "Recno": 19,
    "Landsnr": 36,
    "Landkod": "HUN",
    "Land": "Ungern",
    "Valuta": "HUF"
  },
  {
    "Recno": 50080,
    "Landsnr": 1,
    "Landkod": "USA",
    "Land": "USA",
    "Valuta": "USD"
  },
  {
    "Recno": 204,
    "Landsnr": 598,
    "Landkod": "URY",
    "Land": "Uruguay",
    "Valuta": ""
  },
  {
    "Recno": 205,
    "Landsnr": 998,
    "Landkod": "UZB",
    "Land": "Uzbekistan",
    "Valuta": ""
  },
  {
    "Recno": 208,
    "Landsnr": 681,
    "Landkod": "WLF",
    "Land": "Wallis- och Futunaöarna",
    "Valuta": ""
  },
  {
    "Recno": 213,
    "Landsnr": 678,
    "Landkod": "VUT",
    "Land": "Vanuatu",
    "Valuta": ""
  },
  {
    "Recno": 4,
    "Landsnr": 39,
    "Landkod": "VAT",
    "Land": "Vatikanstaten",
    "Valuta": "EUR"
  },
  {
    "Recno": 207,
    "Landsnr": 58,
    "Landkod": "VEN",
    "Land": "Venezuela",
    "Valuta": ""
  },
  {
    "Recno": 211,
    "Landsnr": 84,
    "Landkod": "VNM",
    "Land": "Vietnam",
    "Valuta": ""
  },
  {
    "Recno": 24,
    "Landsnr": 375,
    "Landkod": "BLR",
    "Land": "Vitryssland",
    "Valuta": "BYR"
  },
  {
    "Recno": 76,
    "Landsnr": 212,
    "Landkod": "ESH",
    "Land": "Västsahara",
    "Valuta": ""
  },
  {
    "Recno": 214,
    "Landsnr": 967,
    "Landkod": "YEM",
    "Land": "Yemen",
    "Valuta": ""
  },
  {
    "Recno": 203,
    "Landsnr": "",
    "Landkod": "UMI",
    "Land": "Yttre UA öarna",
    "Valuta": ""
  },
  {
    "Recno": 218,
    "Landsnr": 243,
    "Landkod": "ZAR",
    "Land": "Zaire",
    "Valuta": ""
  },
  {
    "Recno": 217,
    "Landsnr": 260,
    "Landkod": "ZMB",
    "Land": "Zambia",
    "Valuta": ""
  },
  {
    "Recno": 219,
    "Landsnr": 263,
    "Landkod": "ZWE",
    "Land": "Zimbabwe",
    "Valuta": ""
  },
  {
    "Recno": 222,
    "Landsnr": 358,
    "Landkod": "ALA",
    "Land": "Åland",
    "Valuta": ""
  },
  {
    "Recno": 197,
    "Landsnr": 670,
    "Landkod": "TLS",
    "Land": "Östtimor",
    "Valuta": ""
  }
];
